// 字符串匹配
const stringPattern = /\".*\"/g
// 编号匹配
const codePattern = '\"[0-9]+\"'

/**
 * 对字符串进行编码
 * @param {String} text
 */
exports.encodeString = function(text) {
  const codeData = text.match(stringPattern)
  const flag = '""'
  text = text.replace(stringPattern, flag)
  let value = ''
  let fromIndex = 0
  let index = -1
  let position = 0
  while ((index = text.indexOf(flag, fromIndex)) > -1) {
    value += text.substring(fromIndex, index)
    value += `"${position++}"`
    fromIndex = index + flag.length
  }
  value += text.substr(fromIndex)
  return { value, codePattern, codeData }
}

/**
 * 对字符串进行解码
 * @param {String} text
 * @param {Array} codeData
 */
exports.decodeString = function(text, codeData) {
  const codeRegex = new RegExp(codePattern, 'g')
  const codes = text.match(codeRegex)
  if (!codes) {
    return text
  }
  /* 提取需要的code数据 */
  const arr = []
  for (const item of codes) {
    const position = Number(item.substring(1, item.length - 1))
    arr.push(codeData[position])
  }
  codeData = arr
  /* 按顺序映射code的值 */
  const flag = '""'
  text = text.replace(codeRegex, flag)
  let result = ''
  let fromIndex = 0
  let index = -1
  let position = 0
  while ((index = text.indexOf(flag, fromIndex)) > -1) {
    result += text.substring(fromIndex, index)
    result += codeData[position++]
    fromIndex = index + flag.length
  }
  result += text.substr(fromIndex)
  return result
}

/**
 * 去除中文字符
 * @param {String} text
 */
exports.removeChineseCharacters = function(text) {
  if (!text) {
    return text
  }
  // 使用正则表达式匹配中文字符
  let regex = /[\u4e00-\u9fa5]/g;

  // 去除字符串中的中文字符
  return text.replace(regex, "");
}

/**
 * mbl hbl 前缀去掉逻辑 (判断data是否包含指定前缀，如果包含则删除前缀)
 * @param {String} data
 * @param {String} prefix
 */
exports.deletePrefix = function(data, prefix) {
  if (!data || !prefix) {
    return data
  }
  if (data.startsWith(prefix)) {
    return data.substring(prefix.length)
  }
  return data
}
